import { arrayOf, func, number, shape, string } from 'prop-types'
import { Component } from 'react'

import store, { subscribe } from 'shared/store'
import { HITS_PER_PAGE_FILTER_CHANGED } from 'shared/store/ducks/events'
import Select from 'views/components/molecules/Select'

import './HitsPerPageDesktop.scss'

class HitsPerPageDesktop extends Component {
  constructor(props) {
    super(props)

    const { currentRefinement } = props

    this.state = {
      currentRefinement,
    }
  }

  componentDidMount() {
    subscribe.after(HITS_PER_PAGE_FILTER_CHANGED, payload => {
      const { currentRefinement: beforeChangeRefinement } = this.state
      const { currentRefinement } = payload

      if (beforeChangeRefinement !== currentRefinement) {
        this.setState({
          currentRefinement,
        })
      }
    })
  }

  onChange = event => {
    const { refine } = this.props
    const {
      target: { value },
    } = event

    const hitsPerPage = parseInt(value, 10)
    refine(hitsPerPage)

    store.dispatch({
      type: HITS_PER_PAGE_FILTER_CHANGED,
      currentRefinement: hitsPerPage,
      defaultRefinement: hitsPerPage,
    })
  }

  render() {
    const { items, label, id } = this.props
    const { currentRefinement } = this.state
    const options = items.map(option => ({
      value: option.value,
      text: option.label,
    }))

    return (
      <Select
        selectedValue={currentRefinement}
        label={label}
        id={id}
        name={id}
        onChange={this.onChange}
        data-qa-id="results-per-page-options"
        className="o-HitsPerPage--select"
        options={options}
      />
    )
  }
}

HitsPerPageDesktop.propTypes = {
  items: arrayOf(shape({})).isRequired,
  currentRefinement: number.isRequired,
  refine: func.isRequired,
  label: string.isRequired,
  id: string.isRequired,
}

export default HitsPerPageDesktop
